// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/no-unknown-property */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/exports-last */
/** @jsx jsx */
import React from 'react'
import { Accordion, AccordionItem, AccordionButton, AccordionPanel } from '@chakra-ui/react'
import { graphql, useStaticQuery } from 'gatsby'
import { FiArrowRight } from 'react-icons/fi'
import { GiTicket } from 'react-icons/gi'
import { IoMdArrowDropright, IoMdRibbon } from 'react-icons/io'
import { MdChevronRight } from 'react-icons/md'
import { jsx } from 'theme-ui'
import PacManBottom from './adornments'
import { Box, Button, Heading, NavLink, GatsbyLink as Link } from './elements'
import { Roof, Siding, Windows, Gutters } from '../customIcons'

export const SideBarContainer = ({ children, ...props }) => (
  <div
    {...props}
    sx={{
      borderX: 1,
      borderColor: 'muted',
      borderWidth: 2,
    }}
  >
    <Box bg="primary" position="relative" pb={4} textAlign="center" pt={3} mb={3}>
      {' '}
      <Heading sx={{ color: 'white', fontSize: 5 }}> {props.text} </Heading>{' '}
      <PacManBottom sx={{ height: '25px' }} />
    </Box>
    {children}
  </div>
)
export const SidebarButton = ({ text, icon, ...props }) => (
  <Button
    {...props}
    sx={{
      color: 'primary',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      height: 87,
      pl: 2,
      pr: 0,
      mt: 4,
    }}
  >
    <div
      sx={{
        borderRadius: 90,
        p: 3,
        bg: 'quarternary',
        color: 'white',
        fontSize: 3,
      }}
    >
      {icon}
    </div>

    <div sx={{ color: 'white', fontSize: 3 }}>
      <Heading> {text} </Heading>
    </div>
    <div sx={{ bg: 'quarternary', color: 'white', p: 3 }}>
      <MdChevronRight sx={{ fontSize: 3 }} />
    </div>
  </Button>
)

export function ChildMenu({ item, topLevel = false }) {
  const [show, setShow] = React.useState(false)
  const handleToggle = () => setShow(!show)

  return (
    <AccordionItem>
      <AccordionButton>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            px: [2, 3],
            py: 2,
            alignItems: 'center',
            color: 'heading',
            fontSize: topLevel ? 5 : 2,
            fontFamily: topLevel ? 'heading' : 'body',
            variant: 'links.nav',
            fontWeight: 900,
            '.filled': {
              fill: 'heading ',
              stroke: 'heading ',
            },
            '.active': {
              color: 'primary',
              '.filled': {
                fill: 'primary',
                stroke: 'primary',
              },
            },
          }}
          onClick={handleToggle}
        >
          {topLevel && item.childItems.nodes && item.childItems.nodes.length > 0 ? (
            <Heading
              sx={{
                display: 'flex',
                color: 'black',
                fontSize: 4,
                fontWeight: '900',
                variant: 'links.nav',
              }}
              to="#"
            >
              {item.menuIcon.icon === 'roof' ? (
                <Roof styled={false} sx={{ width: '40px', mr: [2, 3] }} name={item.menuIcon.icon} />
              ) : item.menuIcon.icon === 'siding' ? (
                <Siding
                  styled={false}
                  sx={{ width: '40px', mr: [2, 3] }}
                  name={item.menuIcon.icon}
                />
              ) : item.menuIcon.icon === 'window' ? (
                <Windows
                  styled={false}
                  sx={{ width: '40px', mr: [2, 3] }}
                  name={item.menuIcon.icon}
                />
              ) : item.menuIcon.icon === 'gutters' ? (
                <Gutters
                  styled={false}
                  sx={{ width: '40px', mr: [2, 3] }}
                  name={item.menuIcon.icon}
                />
              ) : (
                <> </>
              )}
              {item.label}
            </Heading>
          ) : (
            <NavLink
              activeClassName="active"
              fontSize={4}
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }}
              to={item.url.split('.com')[1] || item.url}
            >
              {item.menuIcon.icon === 'roof' ? (
                <Roof styled={false} sx={{ width: '40px', mr: [2, 3] }} name={item.menuIcon.icon} />
              ) : item.menuIcon.icon === 'siding' ? (
                <Siding
                  styled={false}
                  sx={{ width: '40px', mr: [2, 3] }}
                  name={item.menuIcon.icon}
                />
              ) : item.menuIcon.icon === 'window' ? (
                <Windows
                  styled={false}
                  sx={{ width: '40px', mr: [2, 3] }}
                  name={item.menuIcon.icon}
                />
              ) : item.menuIcon.icon === 'gutters' ? (
                <Gutters
                  styled={false}
                  sx={{ width: '40px', mr: [2, 3] }}
                  name={item.menuIcon.icon}
                />
              ) : (
                <> </>
              )}
              {!topLevel && <IoMdArrowDropright sx={{ mr: [2] }} />}
              {item.label}
            </NavLink>
          )}
          {item.childItems && item.childItems.nodes.length > 0 ? (
            <p>{(show && '-') || '+'}</p>
          ) : topLevel ? (
            <Link to={item.url.split('.com')[1] || item.url}>
              <FiArrowRight
                sx={{
                  fill: 'primary',
                  color: 'primary',
                  justifySelf: 'flex-end',
                }}
              />
            </Link>
          ) : null}
        </div>
      </AccordionButton>
      {item.childItems &&
        show &&
        item.childItems.nodes.map((child, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <AccordionPanel key={i} isOpen={show}>
            <ChildMenu item={child} />
          </AccordionPanel>
        ))}
    </AccordionItem>
  )
}
export const SideNav = ({ navItems }) => {
  return (
    <SideBarContainer text="Our Services">
      <Accordion>
        {navItems.map((item, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <ChildMenu key={i} topLevel item={item} />
        ))}
      </Accordion>
    </SideBarContainer>
  )
}

const Sidebar = () => {
  const data = useStaticQuery(graphql`
    fragment MenuFields on WpMenuItem {
      id
      label
      url

      menuIcon {
        fieldGroupName
        icon
      }
    }
    {
      allWpMenuItem(filter: { parentDatabaseId: { eq: 0 }, locations: { eq: SIDEBAR_MENU } }) {
        nodes {
          ...MenuFields
          childItems {
            nodes {
              ...MenuFields
              childItems {
                nodes {
                  ...MenuFields
                  childItems {
                    nodes {
                      ...MenuFields
                      childItems {
                        nodes {
                          ...MenuFields
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Box
      sx={{
        width: 360,
        maxWidth: '100%',
      }}
    >
      <SideNav navItems={data.allWpMenuItem.nodes} />
      <Box height={30} />
      <Link to="/coupons">
        <SidebarButton icon={<GiTicket />} text="Coupon Specials" />
      </Link>

      <Link to="/financing">
        <SidebarButton icon={<IoMdRibbon />} text="Financing Available" />
      </Link>
    </Box>
  )
}

export default Sidebar
